const { Mixin } = require('@xingternal/hops');
const { HttpLink, from } = require('@apollo/client');
const { onError } = require('@apollo/client/link/error');
const { graphQLExceptions } = require('../../../monitoring');
// eslint-disable-next-line import/no-extraneous-dependencies
const { print } = require('graphql');

const handleErrors = onError(({ graphQLErrors, networkError, operation }) => {
  const { operationName: name, variables, query } = operation;
  const [{ operation: kind }] = query.definitions;
  const sharedPayload = {
    kind,
    query: print(query).toString(),
    name,
    variables,
  };

  if (graphQLErrors) {
    graphQLErrors.forEach((error) => {
      const { message, path } = error;

      graphQLExceptions(Error(error.message), {
        ...sharedPayload,
        message,
        path,
      });
    });
  }

  if (networkError) {
    graphQLExceptions(Error(networkError.message), {
      ...sharedPayload,
      message: networkError.message,
    });
  }
});

class ApolloMixin extends Mixin {
  getHttpLink = (uri) => new HttpLink({ uri, fetch: this.fetch });

  getApolloLink = () =>
    from([handleErrors, this.getHttpLink(this.config.graphqlUri)]);
}

module.exports = ApolloMixin;
